<template>
    <v-container>
        <v-row>
            <v-col cols=12 md="12" v-if="permisoDocumentos">
                <DocumentosComp></DocumentosComp>
            </v-col>
            <v-col cols=12 md="12">
                <Videos></Videos>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>

import { mapState } from 'vuex';
import MetodosGenerales from '@/utils/metodosgenerales.vue.js';
import Videos from '@/components/pages/documentos/VideosReporte.vue';
import DocumentosComp from '@/components/pages/documentos/DocumentosReporte.vue';
import Inicio from '@/services/main/main.service.js';

export default {
    components: {
        Videos,
        DocumentosComp,
    },
    data: function () {
        return {
            reporte: {
                nrreporte: '',
                svindice: '',
                aiclave: '',
            },
            permisoDocumentos: false,
        };
    },
    computed: {
        ...mapState([
            "domain",
            "informationPage",
            "paginacion",
            "permission",
            "user"
        ])
    },
    methods: {
        async DatosReporte() {
            let datos = await MetodosGenerales.obtenerSessionReporte('reporte');
            this.reporte.nrreporte = datos.nrreporte;
            this.reporte.svindice = datos.svindice;
            this.reporte.aiclave = datos.aiclave;
        },

    },
    async mounted() {
        this.DatosReporte();
        /*Obtener permisos */
        //Permiso para ver archivos: 365 
        await Inicio.VerificarPermisos(this, "365").then((data) => {
            if (data.length > 0) this.permisoDocumentos = true;
        });

    },
}
</script>
